import React, { type ReactNode } from 'react';

import { FilterActionWrapper } from './styles';

export interface FilterActionProps {
    children: ReactNode;
    pressed?: boolean;
    onAction(): void;
}

// TODO: This component was forked from the previous `<FilterLink />` and
// still has remnants of that old design. It is worth re-thinking this
// component to decide if it is actually even needed.
export function FilterAction({ children, pressed = false, onAction }: FilterActionProps) {
    // Intentionally avoiding a `false` value for this prop by passing `undefined`.
    const ariaCurrent = pressed ? 'true' : undefined;

    return (
        <FilterActionWrapper aria-current={ariaCurrent} onClick={onAction}>
            {children}
        </FilterActionWrapper>
    );
}
